"use client";

import { useEffect, useMemo } from "react";
/**
 * Syncs RHF form fields with given values.
 */
export const useSyncFormFields = ({
  fields,
  setValue
}) => {
  const memoizedFields = useMemo(() => fields, [JSON.stringify(fields)]);
  useEffect(() => {
    for (const {
      name,
      value
    } of memoizedFields) {
      setValue(name, value, {
        shouldValidate: true
      });
    }
  }, [memoizedFields, setValue]);
};